let activePresetSyncDepth = 0;
let scrollSnapshot = null;
let pendingConfigureEmailSnapshot = null;
const isScrollable = (element) => {
    const { overflowY, overflowX } = window.getComputedStyle(element);
    return /(auto|scroll|overlay)/.test(`${overflowY}${overflowX}`);
};
export const captureScrollPositions = (anchor) => {
    const elements = [];
    const seen = new Set();
    let node = anchor;
    while (node) {
        if (!seen.has(node) && isScrollable(node)) {
            seen.add(node);
            elements.push({
                element: node,
                scrollTop: node.scrollTop,
                scrollLeft: node.scrollLeft
            });
        }
        node = node.parentElement;
    }
    return {
        elements,
        windowX: window.scrollX,
        windowY: window.scrollY
    };
};
export const restoreScrollPositions = (snapshot) => {
    if (!snapshot)
        return;
    snapshot.elements.forEach(({ element, scrollTop, scrollLeft }) => {
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    });
    window.scrollTo(snapshot.windowX, snapshot.windowY);
};
export const blurFocusedQuillEditor = () => {
    const active = document.activeElement;
    if (active instanceof HTMLElement && active.classList.contains('ql-editor')) {
        active.blur();
    }
};
const runDeferredScrollRestore = () => {
    const snapshot = scrollSnapshot;
    const configureSnapshot = pendingConfigureEmailSnapshot;
    const restore = () => {
        blurFocusedQuillEditor();
        restoreScrollPositions(configureSnapshot);
        restoreScrollPositions(snapshot);
    };
    restore();
    window.requestAnimationFrame(() => {
        restore();
        window.requestAnimationFrame(restore);
    });
};
export const captureConfigureEmailPageScroll = () => {
    pendingConfigureEmailSnapshot = captureScrollPositions(document.body);
};
export const enterEmailPresetProgrammaticSync = (anchor) => {
    activePresetSyncDepth += 1;
    if (!scrollSnapshot) {
        scrollSnapshot = captureScrollPositions(anchor);
    }
};
export const leaveEmailPresetProgrammaticSync = () => {
    activePresetSyncDepth = Math.max(0, activePresetSyncDepth - 1);
    blurFocusedQuillEditor();
    queueMicrotask(() => {
        if (activePresetSyncDepth > 0)
            return;
        runDeferredScrollRestore();
    });
};
export const restoreScrollPositionsDeferred = (snapshot) => {
    if (!snapshot)
        return;
    const restore = () => restoreScrollPositions(snapshot);
    restore();
    window.requestAnimationFrame(() => {
        restore();
        window.requestAnimationFrame(restore);
    });
};
export const restoreConfigureEmailScroll = (panel) => {
    if (panel) {
        panel.scrollTop = 0;
        panel.scrollLeft = 0;
    }
    const run = () => {
        blurFocusedQuillEditor();
        restoreScrollPositions(pendingConfigureEmailSnapshot);
        restoreScrollPositions(scrollSnapshot);
        if (panel) {
            panel.scrollTop = 0;
            panel.scrollLeft = 0;
        }
    };
    run();
    window.requestAnimationFrame(() => {
        run();
        window.requestAnimationFrame(run);
    });
    window.setTimeout(run, 0);
    window.setTimeout(run, 50);
};
